import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { NOT_APPROVED_PATH, NOT_FOUND_PATH } from '../../utils/paths';
import { useIsAvailableFeatureForCustomer } from '../../domains/features/useIsAvailableFeatureForCustomer/useIsAvailableFeatureForCustomer';
import { LogoLoader, LogoLoaderSize } from '../UI/LogoLoader';

interface CustomFeatureGuardProps {
  children: ReactNode;
  auth: boolean | undefined;
  customerId: string;
  featureName: string;
  isPending?: boolean;
}

const CustomFeatureGuard: React.FC<CustomFeatureGuardProps> = ({
  children,
  auth,
  customerId,
  featureName,
  isPending,
}: CustomFeatureGuardProps) => {
  const { response } = useIsAvailableFeatureForCustomer(
    customerId,
    featureName
  );
  if (isPending) return null;

  if (!auth) return <Navigate to={NOT_APPROVED_PATH} replace />;

  if (response.isLoading || response.isFetching)
    return <LogoLoader size={LogoLoaderSize.M} />;

  if (!response.data?.hasAccess)
    return <Navigate to={NOT_FOUND_PATH} replace />;

  return <>{children}</>;
};

export default CustomFeatureGuard;
